/* Base style for the chip */
.chip {
  padding: 0.3em 1em;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* margin: 0.5em; */
  transition: background-color 0.3s, color 0.3s;
  max-width: 100%; /* Ensures it fits the container */
  max-height: 100%;
}

/* Styles for different statuses */
.success {
  background-color: #4caf50; /* Green */
  color: white;
}

.warning {
  background-color: #ffeb3b; /* Yellow */
  color: #212121; /* Use a darker text color for contrast */
}

.error {
  background-color: #f44336; /* Red */
  color: white;
}

.info {
  background-color: rgb(52, 120, 176);
  color: white;
}

/* Default style if no status is matched */
.default {
  background-color: rgb(207, 207, 207);
  color: black; /* Dark Grey */
}

.dense {
  padding-top: 0;
  padding-bottom: 0;
}

p {
  margin-top: 0;
  margin-bottom: 0;
}